import { useQuery } from "@tanstack/react-query";

import type { Note, UUID } from "@/core/types";

import { getNotesSummary } from "../queryFunctions/getNotesSummary";
import { memberNotesKeys } from "../keyFactory";

type UseNotesSummaryProps = {
  patientId: UUID;
  select?: (data: Note[]) => Note[];
};

export function useNotesSummary({ patientId, select }: UseNotesSummaryProps) {
  return useQuery({
    queryFn: () => getNotesSummary(patientId),
    queryKey: memberNotesKeys.summary(patientId),
    select,
    staleTime: 0,
  });
}
